import { validateNumber } from 'ember-changeset-validations/validators';

export const PriceValidation = {
  accommodation: [validateNumber({ integer: true, allowBlank: false })],
  cleaningFee: [validateNumber({ integer: true, allowBlank: false })],
};
